import { useContext } from 'react'

import { ShopAndRuntimeConfigContext } from 'views/components/templates/helpers'

export const getPublicConfig = () => {
  const { publicConfig } = useContext(ShopAndRuntimeConfigContext)

  return publicConfig
}

export const getPageProperties = () => {
  const { pageProperties } = useContext(ShopAndRuntimeConfigContext)

  return pageProperties
}
